<template>
  <v-row justify="center">
    <v-col>
      <InfoCard
        class="mx-auto"
        title="Clientes Atendidos"
        :content="valueCustomersAttention"
        :max-width="300"
        :font-weight-content="600"
        :font-size-content="30"
        :border-radius="10"
      />
    </v-col>
    <v-col>
      <InfoCard
        class="mx-auto"
        title="Efectividad"
        :content="valueEffectiveness"
        :max-width="300"
        :font-weight-content="600"
        :font-size-content="30"
        :border-radius="10"
      />
    </v-col>
  </v-row>
</template>

<script>
import InfoCard from '@/infrastructure/vue/components/common/cards/InfoCard';

export default {
  name: 'AttentionData',
  props: {
    valueCustomersAttention: { type: String, default: '' },
    valueEffectiveness: { type: String, default: '' },
  },
  components: {
    InfoCard,
  },
};
</script>

<style></style>
